import { Col, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import { AppState } from "../redux/types";
import { CATEGORIES, categoryOptions } from "../utils/constants";

const styles = {
    background: "transparent",
    border: "none",
    padding: "0.5rem 1.5rem",
    margin: 0,
    color: "var(--text-primary)",
    height: "fit",
    width: "auto",
    alignSelf: "end",
    paddingTop: "2rem",
    fontSize: "1.1rem",
    marginBottom: "-2rem",
};

const StepsHeader = ({ step1, step2, step3, step4, step5 }: any) => {
    const rawCategory = useSelector((state: AppState) => state.categories.category?.attributes.slug);
    const category = CATEGORIES[rawCategory as keyof typeof CATEGORIES] || rawCategory;

    if (category === categoryOptions.app) {
        return (
            <>
                <Row>
                    <Col sm={12} lg={12} md={12}>
                        <section className="justify-content-center my-4 steps-section ">
                            <ul className="circles-row">
                                {step1 ? (
                                    <li className="step" style={{ ...styles, fontWeight: "700" }}>
                                        Luo tili
                                    </li>
                                ) : (
                                    <li className="step" style={styles}>
                                        Luo tili
                                    </li>
                                )}
                                <li className="step-line" />
                                {step2 ? (
                                    <li className="step " style={styles}>
                                        Lisää seniori
                                    </li>
                                ) : (
                                    <li className="step" style={styles}>
                                        Lisää seniori
                                    </li>
                                )}
                                <li className="step-line" />
                                {step3 ? (
                                    <li className="step " style={styles}>
                                        Lisää läheiset
                                    </li>
                                ) : (
                                    <li className="step" style={styles}>
                                        Lisää läheiset
                                    </li>
                                )}
                            </ul>
                        </section>
                    </Col>
                </Row>
            </>
        );
    }

    // Original flow for other categories
    return (
        <>
            <Row>
                <Col sm={12} lg={12} md={12}>
                    <section className="justify-content-center my-4 steps-section">
                        <ul className="circles-row">
                            {step1 ? (
                                <li className="step active">
                                    <i className="icon-in-circle active fas fa-shopping-cart" />
                                    Ostoskori
                                </li>
                            ) : (
                                <li className="step">
                                    <i className="icon-in-circle fas fa-shopping-cart" />
                                    Ostoskori
                                </li>
                            )}
                            {category !== "alarm" && (
                                <>
                                    <li className="step-line" />
                                    {step2 ? (
                                        <li className="step active">
                                            <i className="icon-in-circle active fas fa-user-circle" />
                                            Tilaa ja luo tili
                                        </li>
                                    ) : (
                                        <li className="step">
                                            <i className="icon-in-circle fas fa-user-circle" />
                                            Tilaa ja luo tili
                                        </li>
                                    )}
                                </>
                            )}
                            <li className="step-line" />
                            {step3 ? (
                                <li className="step active">
                                    <i className="icon-in-circle active fas fa-truck" />
                                    Yhteystiedot, toimitus
                                </li>
                            ) : (
                                <li className="step">
                                    <i className="icon-in-circle fas fa-truck" />
                                    Yhteystiedot, toimitus
                                </li>
                            )}
                            <li className="step-line" />
                            {step4 ? (
                                <li className="step active">
                                    <i className="icon-in-circle far fa-credit-card active" />
                                    Maksu
                                </li>
                            ) : (
                                <li className="step">
                                    <i className="icon-in-circle far fa-credit-card" />
                                    Maksu
                                </li>
                            )}
                            <li className="step-line" />
                            {step5 ? (
                                <li className="step active">
                                    <i className="icon-in-circle fas fa-address-card active" />
                                    {category !== "alarm" ? "Luo perhetili" : "Yhteenveto"}
                                </li>
                            ) : (
                                <li className="step">
                                    <i className="icon-in-circle fas fa-address-card" />
                                    {category !== "alarm" ? "Luo perhetili" : "Yhteenveto"}
                                </li>
                            )}
                        </ul>
                    </section>
                </Col>
            </Row>
        </>
    );
};

export default StepsHeader;
